import React from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import { GiProcessor } from "react-icons/gi";

import Footer from "../../components/Footer/OrgFooter";
import Header from "../../components/Header/OrgHeader";
import Helmet from "../../components/Helmet";
import { updateMe, updateOrg } from "../../state/global";
import * as sessions from "../../utils/sessions";
import isBrowser from "../../utils/isBrowser";

import "../base.css";

const Container = ({ children }) => (
    <div style={{
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    }}>
        { children }
    </div>
);

const OrgLayout = ({ children, me, updateMe, org, updateOrg, title, description, image }) => {
    const [ success, setSuccess ] = React.useState(undefined);

    React.useEffect(() => {
        const profile = sessions.getSessionValue(sessions.PROFILE_KEY);

        if (me && me.token) {
        } else {
            if (profile && profile.token) {
                updateMe(profile);
            } else {
            }
        }

        if (profile && profile.token && !(me && me.token)) return;

        if (!isBrowser()) return;

        const code = window.location.pathname.split("/").filter(path => path)[0];

        window.fetch(process.env.API_URL + "/orgs/code/" + code, {
            headers: {
                Accept: "application/json",
                Authorization: me.token,
            },
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error(res.statusText);
        }).then(org => {
            setSuccess(true);
            updateOrg(org);
        }).catch((e) => {
            console.error(e);
            setSuccess(false);
        });

        return () => {
            updateOrg({});
        };
    }, [ me, updateMe, updateOrg ]);

    return (
        <div>
            <Helmet
                title={ title || org.name }
                description={ description }
                image={ image || org.icon }
            />
            <Header
                code={ org.code }
                name={ org.name }
                icon={ org.icon }
                permissions={ org.permissions }
            />
            {
                success === true
                ?   org.permissions || org.visible
                    ?   <main
                            css={{
                                margin: "0 auto",
                                padding: 15,
                                display: "flex",
                                flexDirection: "column",
                                minHeight: "calc(100vh)",
                                maxWidth: 1000,
                            }}
                        >
                            { children }
                        </main>
                    :   <Container>
                            <div>Shh! This is a private place.</div>
                            <div css={{ marginTop: 5, color: "lightgrey", fontSize: ".9em" }}>You're not supposed to be here.</div>
                            <div css={{
                                marginTop: 20,
                            }}>
                                <Link to={ isBrowser() ? "/authorize?path=" + window.location.pathname : "/authorize" }>
                                    <button>
                                        But, I'm a member here!
                                    </button>
                                </Link>
                            </div>
                        </Container>
                :   success === false
                    ?   <Container>
                            <div>There's nothing here, yet.</div>
                            <div css={{
                                marginTop: 20,
                            }}>
                                <Link to="/">
                                    <button>
                                        Build something amazing!
                                    </button>
                                </Link>
                            </div>
                        </Container>
                    :   <Container>
                            <div>
                                <GiProcessor size={ 48 } />
                            </div>
                            <div css={{
                                marginTop: 20,
                            }}>
                                Crunching Data
                            </div>
                        </Container>
            }
            <Footer />
        </div>
    );
};

export default connect(
    state => ({ me: state.global.me, org: state.global.org }),
    dispatch => ({ updateMe: me => dispatch(updateMe(me)), updateOrg: org => dispatch(updateOrg(org)) }),
)(OrgLayout);
